
/**
 * Utility functions for Web Vitals
 */

/**
 * Generate a unique ID for a metric
 * @param name The metric name
 * @returns A unique metric ID
 */
export function generateMetricId(name: string): string {
  return `${name}_${Date.now()}`;
}
